import { useMemo } from "react";
import { useIntl } from "react-intl";
import { PeriodicalFrequencyEnum } from "../types/Api";
import { frequencyLabelId } from "../utils/frequencyLabel";
export var usePeriodicalFrequencyOptions = function () {
    var formatMessage = useIntl().formatMessage;
    return useMemo(function () {
        return Object.values(PeriodicalFrequencyEnum).map(function (value) { return ({
            value: value,
            label: formatMessage({ id: frequencyLabelId(value) }),
        }); });
    }, [formatMessage]);
};
